module.exports = __webpack_public_path__ + "media/images/Carta-TI-ac43b355aed60843770686dc6573e780.png";